._1e7rti50 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
}
._1e7rti51 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
._1e7rti52 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
._1e7rti53 {
  color: var(--xtj8iy3a);
  font-size: 12px;
  padding-top: 4px;
}